import React from 'react';

function InputField({
  id,
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  hint,
  error,
  disabled = false,
  required = false,
}) {
  return (
    <div className="flex flex-col">
      <label htmlFor={id} className="font-sans text-small font-semibold text-neutral-700 mb-2">
        {label}
        {required && <span className="text-error ml-1" aria-hidden="true">*</span>}
      </label>
      <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className={`
          w-full bg-neutral-100 border rounded-md
          px-4 py-3 font-sans text-body text-neutral-800
          placeholder:text-neutral-400
          transition-colors duration-fast
          hover:border-neutral-300
          focus:outline-none focus:border-primary-500 focus:bg-surface-card focus:ring-2 focus:ring-primary-500 focus:ring-offset-0
          disabled:opacity-40 disabled:cursor-not-allowed
          ${error ? 'border-error bg-surface-card' : 'border-neutral-200'}
        `}
      />
      {(error || hint) && (
        <p className={`text-caption mt-1 ${error ? 'text-error' : 'text-neutral-500'}`}>
          {error || hint}
        </p>
      )}
    </div>
  );
}

export default InputField;
